import React from "react";
import Marquee from "react-fast-marquee";

export default function BrandMarquee() {
  const item = "FRE3BRD";
  return (
    <div
      data-testid="marquee"
      className="relative border-y border-zinc-900 bg-black py-5 md:py-7 select-none"
    >
      <Marquee speed={60} gradient={false} autoFill>
        <div className="flex items-center gap-8 pr-8">
          <span className="font-display font-black text-4xl md:text-6xl tracking-tighter text-stroke">
            {item}
          </span>
          <span className="font-mono text-xs md:text-sm uppercase tracking-widest text-zinc-500">
            Out Now
          </span>
          <span className="font-display font-black text-4xl md:text-6xl tracking-tighter text-white">
            {item}
          </span>
          <span className="font-mono text-xs md:text-sm uppercase tracking-widest text-zinc-500">
            Free Download
          </span>
        </div>
      </Marquee>
    </div>
  );
}
